/**
 *
 * @module b-list
 */
define('toolkit/b-list/b-list', [
	'jquery',
	'toolkit/b-toolkit/b-toolkit',
	'toolkit-common/keymaster/keymaster'
], function ($, toolkit, key){
	'use strict';

	return toolkit.create('b-list', {
		init: function (){

			this.__itemSelector = this.__itemSelector || this.s('__list__item');
			this.__groupSelector = this.__groupSelector || this.s('__group_scroll');

			/** AC-141 */
			this.__listSelector = this.__listSelector || this.s('__list');

			this._initEvents();

			this._hide = this._hide.bind(this);
			this._onKeyArrows = this._onKeyArrows.bind(this);
			this._onKeyEnter  = this._onKeyEnter.bind(this);

			toolkit['b-toolkit'].fn.init.apply(this, arguments);
		},

		_initEvents: function() {
			//Небольшой костыль, чтоб не поломать контекстное меню у папок
			if(!this.$list){
				this.$list = this.$('__list');
			}

			// теперь придется вместо :hover выставлять класс при движении мышкой
			this.$list
				.on('mouseenter.' + this.uniqid, this.__itemSelector, this._onItemHover.bind(this))
				.on('mouseleave.' + this.uniqid, this.__itemSelector, this._onListMouseLeave.bind(this));

			toolkit['b-toolkit'].fn.init.apply(this, arguments);
		},

		onRender: function() {
			delete this.$list;
			this._initEvents();
		},

		/**
		 * Если не удалось найти ни одного елемента возвращает false
		 *
		 * @private
		 */
		_unselectAll: function() {
			var $items = this.$list.find(this.__itemSelector);
			$items.toggleMod('selected', false);

			return !!$items.length;
		},



		/**
		 * Включить/выключить использование горячих кнопок
		 * @param {boolean} state
		 * @memberOf b-list#
		 */
		useHotkeys: function (state) {
			key[state ? 'on' : 'off']('esc, left', this.el, this._hide);
			key[state ? 'on' : 'off']('up, down', this.el, this._onKeyArrows);
			key[state ? 'on' : 'off']('enter, right', this.el, this._onKeyEnter);
			key[state ? 'on' : 'off']('space', this.el, this._onKeyEnter);
		},


		/**
		 * @protected
		 * @memberOf b-list#
		 */
		_hide: function (evt){
			// override this
		},


		/**
		 * @deprecated
		 * @memberOf b-list#
		 */
		_toggleKeyboard: function (on) {
			this.useHotkeys(on);
		},


		_onItemHover: function (evt) {
			$(evt.currentTarget).toggleMod('selected', true);

			var $item = $(evt.target).closest(this.__itemSelector);
			if ($item.length && !$item.hasMod('unselectable') && !$item.hasMod('disabled') ) {
				$item.toggleMod('selected', true);
			}

		},

		_onListMouseLeave: function (evt) {
			//Хак, чтобы не поломалось контекстое меню у папок
			//Если ты username решил тут что-то поправить, не забудь глянуть в
			// почте разные дропдауны, особенно в контекстном меню
			if (!this._unselectAll()) {
				$(evt.currentTarget).toggleMod('selected', false);
			}
		},


		_onKeyArrows: function (/** Event */evt, obj) {
			var up = obj.key == 'up';

			var $item = this._getNextItem(up);
			$item.toggleMod('selected', true);
			this._checkItemUnderScroll($item);

			evt.preventDefault();
			evt.stopImmediatePropagation();
		},


		_onKeyEnter: function (evt, obj) {
			var $item = this.$list.find(this.__itemSelector +'_selected');

			if (!$item.length) {
				$item = this.$list.find(this.__itemSelector +'_current');
			}

			evt.preventDefault();
			evt.stopImmediatePropagation();

			if ($item.length) {
				if (obj.key == 'right' && !$item.hasMod('nested')) {
					// right только для элементов с вложенным меню
					return;
				}

				$item[0].click();
			}
		},

		_getNextItem: function (up) {
			var $items = this.$list.find(this.__itemSelector)
				.not(this.__itemSelector + '_unselectable')
				.not(this.__itemSelector + '_disabled'),

				$currentItem,
				currentItemIndex = -1,
				nextItemIndex,
				i = 0;

			for (i = 0; i < $items.length; i++) {
				$currentItem = $($items[i]);
				if ($currentItem.hasMod('selected')) {
					currentItemIndex = i;
					break;
				}
			}

			if (currentItemIndex != -1) {
				$items.toggleMod('selected', false);

				nextItemIndex = up ?
					(currentItemIndex === 0 ? -1 : currentItemIndex - 1) :
					(currentItemIndex === $items.length - 1 ? 0 : currentItemIndex + 1)
				;
			}
			else {
				// если никто не выбран, то выбираем первый для кнопки down и последний для up
				nextItemIndex = up ?  -1 : 0;
			}

			return $items.eq(nextItemIndex);
		},

		/**
		 * если элемент находится в составе группы со скроллом,
		 * нужно подскролливать группу, чтобы элемент был на виду
		 * @param $item
		 * @private
		 * @memberOf b-list#
		 */
		_checkItemUnderScroll: function ($item) {
			var $group = $item.closest(this.__groupSelector + ',' + this.__listSelector);

			if ($group.length) {
				var offset = $item.offset(),
					itemHeight = $item.outerHeight(),
					groupOffset = $group.offset(),
					groupHeight = $group.height(),
					scrollTop = $group.scrollTop(),
					diff = offset.top - groupOffset.top;

				if (diff < 0) {
					// нужно проскроллить вверх
					$group.scrollTop( scrollTop + diff );
				}
				else if (diff + itemHeight > groupHeight) {
					// нужно проскроллить вниз
					$group.scrollTop( scrollTop + diff + itemHeight - groupHeight );
				}
			}
		},

		_unbindEvents: function () {
			// jshint expr:true
			this.$list && this.$list.off('.' + this.uniqid);
			this.useHotkeys(false);
		},

		/**
		 * @desc Добавить новые вьюхи без вызова рендеринга
		 * @public
		 * @params {Array<Object>}
		 */
		appendItems: function (items) {
			var elements;

			elements = items.map(function(item){
				return new toolkit[item.block]({
					$el: $('<div />'),
					renderMode: 'replace',
					template: this.template,
					data: item
				}).render().$el;
			}, this);

			this.data.items = this.data.items.concat(items);

			this.$list.append(elements);
		},

		refresh: function () {
			this._unbindEvents();
			this.$list = null;
			this.render();
			this.init();
		},

		destroy: function () {
			// https://jira.mail.ru/browse/MAIL-35279
			this._unbindEvents();
			toolkit['b-toolkit'].fn.destroy.apply(this, arguments);
			this.$list = null;
		}
	});
});
